import IntegrationMessagesListPage from '../shared/IntegrationMessagesListPage';

const OutboxMessagesListPage = () => <IntegrationMessagesListPage kind="outbox" />;

export default OutboxMessagesListPage;
